import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { imgUrl } from "@/lib/api";
import { EASE } from "./Reveal";

const Row = ({ item, i }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const flip = i % 2 === 1;
  return (
    <div ref={ref} className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-center">
      <motion.div initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }}
        className={`lg:col-span-7 ${flip ? "lg:order-2" : ""}`}>
        <Link to={`/item/${item.id}`} data-testid={`featured-project-${item.id}`}
          className="group block relative aspect-[16/11] overflow-hidden border border-[#D4AF37]/20">
          <motion.div variants={{ hidden: { clipPath: "inset(0 0 0 100%)" }, show: { clipPath: "inset(0 0 0 0%)" } }}
            transition={{ duration: 1.4, ease: EASE }} className="absolute inset-0">
            <motion.img src={imgUrl(item.images?.[0])} alt={item.name} style={{ y, scale: 1.18 }}
              className="w-full h-full object-cover group-hover:brightness-110 transition-[filter] duration-700" />
          </motion.div>
        </Link>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 1, ease: EASE, delay: 0.2 }} className={`lg:col-span-5 ${flip ? "lg:order-1" : ""}`}>
        <span className="font-display text-[7rem] leading-none text-transparent [-webkit-text-stroke:1px_rgba(212,175,55,0.5)]">
          {String(i + 1).padStart(2, "0")}
        </span>
        <p className="mt-2 font-mono-j text-xs uppercase tracking-[0.3em] text-[#D4AF37]">{item.code}</p>
        <h3 className="mt-3 font-display text-4xl sm:text-5xl text-[#F5F3EF]">{item.name}</h3>
        <p className="mt-5 text-[#A09E97] max-w-md leading-relaxed">{item.description}</p>
        <div className="mt-6 flex flex-wrap gap-x-8 gap-y-2">
          {(item.specs || []).slice(0, 3).map((s) => (
            <span key={s.label} className="text-sm"><span className="text-[#A09E97]">{s.label} — </span><span className="text-[#F5F3EF]">{s.value}</span></span>
          ))}
        </div>
        <Link to={`/item/${item.id}`} className="nav-link mt-8 inline-block font-mono-j text-xs uppercase tracking-[0.25em] text-[#E5C158]">
          View project
        </Link>
      </motion.div>
    </div>
  );
};

export const FeaturedProjects = ({ items }) => (
  <div className="space-y-28 lg:space-y-40" data-testid="featured-projects">
    {items.map((it, i) => <Row key={it.id} item={it} i={i} />)}
  </div>
);
